// src/stone/icons/Rings.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Rings = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6.707 4.041a7.51 7.51 0 0 1 7.911 9.832l-.315.949-1.898-.63.315-.949A5.51 5.51 0 1 0 9.06 16.79l.959-.285.57 1.917-.959.285A7.51 7.51 0 1 1 6.707 4.04" }),
      /* @__PURE__ */ jsx("path", { d: "M14.37 4.33a7.509 7.509 0 1 1-4.988 4.833l.315-.949 1.898.63-.315.949a5.509 5.509 0 1 0 3.66-3.546l-.96.285-.57-1.917z" })
    ]
  }
);
var Rings_default = Rings;

export {
  Rings,
  Rings_default
};
